import React from "react";
import { Box, Typography } from "@mui/material";
import MapCard from "./MapCard";
import {
    MOBILE_NAV_MQ,
    SETTINGS_CONTENT_COLUMN_SX,
    SETTINGS_SECTION_BODY_SX,
    SETTINGS_SECTION_DESC_SX,
    SETTINGS_SECTION_HEADER_SX,
    SETTINGS_SECTION_PAD_SX,
    SETTINGS_SECTION_TITLE_SX,
} from "./lobbySettingsStyles";

export default function MapPoolTab({
    lobbyMapsSelected = [],
    availableMaps = [],
    mapEditingDisabled = false,
    canEditLobbySettings = false,
    currentLobbyCode = null,
    canRefineSelections = true,
    onMapClicked,
    onLeaderMapUpdate,
    queueMode = "standard",
}) {
    const handleMapClick = (mapName) => {
        if (mapEditingDisabled) {
            return;
        }
        const normalizedMapName = String(mapName || "")
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "_");

        if (canEditLobbySettings && currentLobbyCode && onLeaderMapUpdate) {
            onLeaderMapUpdate(normalizedMapName);
        } else if (onMapClicked) {
            onMapClicked(normalizedMapName);
        }
    };

    return (
        <Box sx={SETTINGS_SECTION_PAD_SX}>
            <Box sx={SETTINGS_CONTENT_COLUMN_SX}>
                <Box sx={SETTINGS_SECTION_HEADER_SX}>
                    <Typography sx={SETTINGS_SECTION_TITLE_SX}>
                        Map Pool
                    </Typography>
                    <Typography sx={SETTINGS_SECTION_DESC_SX}>
                        {!canRefineSelections
                            ? "Free keeps all maps active. Upgrade to Premium or Pro to refine this list."
                            : queueMode === "wingman"
                              ? "Select the wingman maps you want in rotation."
                              : "Select the exact map pool you want in rotation."}
                    </Typography>
                </Box>

                <Box sx={SETTINGS_SECTION_BODY_SX}>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(3, minmax(0, 1fr))",
                            },
                            gap: "0.85rem",
                            [MOBILE_NAV_MQ]: {
                                gap: "0.55rem",
                            },
                        }}
                    >
                        {availableMaps.map((name) => (
                            <MapCard
                                key={name}
                                name={name}
                                mapsSelected={lobbyMapsSelected}
                                onMapClicked={handleMapClick}
                                disabled={mapEditingDisabled}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
